import axios from "axios";

// Create the axios instance
export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});


// Utility to check and handle inactivity
const handleInactivity = () => {
  if (typeof window !== "undefined" && typeof localStorage !== "undefined") {
    const lastActiveTime = localStorage.getItem("lastActiveTime");
    const currentTime = new Date().getTime();

    if (lastActiveTime && currentTime - lastActiveTime > 60 * 60 * 1000) {
      localStorage.removeItem("token");
      localStorage.removeItem("lastActiveTime");
      window.location = "/";
    }
  }
};

const resetActivityTimeout = () => {
  if (typeof window !== "undefined" && typeof localStorage !== "undefined") {
    localStorage.setItem("lastActiveTime", new Date().getTime());
  }
};

if (typeof window !== "undefined") {
  ["click", "mousemove", "keydown"].forEach((event) => {
    window.addEventListener(event, resetActivityTimeout);
  });

  setInterval(handleInactivity, 60 * 1000);
}

// Intercept requests to add the token
axiosInstance.interceptors.request.use(
  (config) => {
    if (typeof localStorage !== "undefined") {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


// Intercept responses to handle 401 errors (unauthorized)
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (
      error.response &&
      error.response.status === 401 &&
      typeof window !== "undefined"
    ) {
      const token = localStorage.getItem("token");
      if (token) {
        localStorage.removeItem("token");
        localStorage.removeItem("lastActiveTime");
        window.location = "/";
      }
    }
    return Promise.reject(error);
  }
);
